// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"2edbaf83","201":"bb8f397f","294":"c6347828","338":"65666705","341":"37d15035","344":"45a6178e","360":"d981fb77","398":"78390674","538":"ee40321a","654":"2cf0e1ae","787":"78140b36","887":"d3c80d86","890":"92f96f06","920":"fce5985e"}[chunkId] + ".chunk.js";
};